<div class="box custom-box h-full flex flex-col">
  <div class="box-header">
    <div class="box-title">Mapa de Calor de Atividades</div>
    <div class="text-right">
        <p class="text-xs text-muted">
          Total: {{ getTotalActivities() }} atividades
        </p>
      </div>
  </div>
  
  <div class="box-body !p-0 !pt-3 flex-1 flex flex-col">
    <!-- Loading State -->
    <div *ngIf="loading" class="flex items-center justify-center p-8">
      <app-loading-spinner message="Carregando dados de atividade..."></app-loading-spinner>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="flex items-center justify-center p-8">
      <div class="text-center text-danger">
        <div class="flex items-center gap-2 mb-4">
          <i class="ri-error-warning-line text-xl"></i>
          <p class="!mt-1">Erro ao carregar dados de atividade</p>
        </div>
        <button class="ti-btn ti-btn-primary-full !py-1 !px-2 ti-btn-wave" (click)="loadActivityHeatmap()">
          <i class="ri-refresh-line"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <!-- Success State - Heatmap Chart -->
    <div *ngIf="!loading && !error && activityData.length > 0" id="activity-heatmap-chart" class="flex-1">
      <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [dataLabels]="chartOptions.dataLabels"
        [colors]="chartOptions.colors"
        [plotOptions]="chartOptions.plotOptions"
        [title]="chartOptions.title"
        [xaxis]="chartOptions.xaxis"
        [yaxis]="chartOptions.yaxis"
        [tooltip]="chartOptions.tooltip"
        [grid]="chartOptions.grid">
      </apx-chart>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && !error && activityData.length === 0" class="flex items-center justify-center p-8">
      <div class="text-center">
        <div class="text-muted">
          <i class="ri-bar-chart-line text-5xl mb-3"></i>
          <h6>Nenhuma atividade encontrada</h6>
          <p class="mb-0">Não há dados de atividade para exibir no período selecionado.</p>
        </div>
      </div>
    </div>
  </div>

</div>
